import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { id: "perspective", label: "Perspective" },
  { id: "live-schedule", label: "Live View" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#04070D]/85 backdrop-blur-md border-b border-[#1E2A3B]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          data-testid="logo-home-link"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="cursor-pointer"
        >
          <Logo size="md" />
        </button>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="px-4 py-2 text-sm text-[#94A3B8] hover:text-[#F1F5F9] transition-colors font-mono-accent text-[11px]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-quote"
            onClick={() => go("contact")}
            className="ml-4 btn-amber"
          >
            Request Proposal
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#F1F5F9]"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#1E2A3B] bg-[#04070D]/95 backdrop-blur-md">
          <div className="px-6 py-4 flex flex-col gap-2">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left py-3 text-[#94A3B8] hover:text-white font-mono-accent text-xs"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta"
              onClick={() => go("contact")}
              className="btn-amber mt-3 justify-center"
            >
              Request Proposal
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
